import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import React from 'react'
import { View } from 'react-native'

interface EmptyComponentProps {
  screenType: string
  tabType: string | undefined
}

export default function EmptyComponent({
  screenType,
  tabType,
}: EmptyComponentProps) {
  const styles = useStyles()
  return (
    <View style={styles.emptyComponent}>
      <Text h4 style={styles.emptyComponentText}>
        {`No ${
          screenType === 'dm' && tabType === 'mentions'
            ? t(tabType)
            : t(screenType)
        }.`}
      </Text>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  emptyComponent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyComponentText: {
    color: theme.colors?.grey0,
  },
}))
